import { useTranslation } from 'react-i18next';
import EventDetailsIcon from '@mui/icons-material/DateRange';
import { EventDetailsData, EventDetailsForm } from 'components/EventForms';
import {
  Dialog,
  SectionTitle,
  TextV2,
} from '@insights-ltd/design-library/components';
import { useState } from 'react';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Box } from '@mui/material';
import EditFormNavigation from './EditFormNavigation';
import { EditProps } from './types';

const EditEventDetails = ({
  eventForm,
  onCancel,
  saveEvent,
  saving,
  invitedCount = 0,
}: EditProps) => {
  const { t } = useTranslation();

  const [modalOpen, setModalOpen] = useState(false);
  const [editEventData, setEditEventData] =
    useState<EventDetailsData>(eventForm);

  const handleFormSubmit = (formData: EventDetailsData) => {
    if (
      eventForm.deadlineAt?.toISODate() !== formData.deadlineAt?.toISODate()
    ) {
      setEditEventData(formData);
      setModalOpen(true);
    } else {
      saveEvent(formData);
    }
  };

  const handleModalSave = () => {
    saveEvent(editEventData);
  };

  return (
    <>
      <Box
        sx={{
          mt: spacingSizeMap.L,
          mb: spacingSizeMap.L,
        }}
      >
        <SectionTitle
          icon={{ icon: <EventDetailsIcon />, iconColour: 'pink' }}
          text={t('ui.event-management.events.create.event-details')}
        />
      </Box>
      <EventDetailsForm
        event={eventForm}
        onSubmit={handleFormSubmit}
        invitedCount={invitedCount}
      >
        {({ isSubmitDisabled }) => (
          <EditFormNavigation
            onCancel={onCancel}
            saving={saving}
            disabled={isSubmitDisabled}
          />
        )}
      </EventDetailsForm>
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleModalSave}
        disablePrimaryButton={saving}
        title={t(
          'ui.event-management.events.edit.dialog-deadline-update.title',
        )}
        content={
          <>
            <TextV2 sx={{ marginBottom: '1rem' }}>
              {t(
                'ui.event-management.events.edit.dialog-deadline-update.content.text-1',
              )}
            </TextV2>
            <TextV2>
              {t(
                'ui.event-management.events.edit.dialog-deadline-update.content.text-2',
              )}
            </TextV2>
          </>
        }
        primaryButtonText={t(
          'ui.event-management.events.edit.dialog-deadline-update.primary-button',
        )}
        secondaryButtonText={t(
          'ui.event-management.events.edit.dialog-deadline-update.secondary-button',
        )}
      />
    </>
  );
};

export default EditEventDetails;
